const zh = {
  sidebar: {
    community: 'Community',
    electricLock: 'Electric Lock',
    sipAccount: 'Sip Account',
    settings: 'Settings',
    roomSip: 'Room Sip',
    staffSip: 'Staff Sip',
    doorLock: 'Door Lock',
    callCenter: 'Call Center',
    ecardSetting: 'Ecard Setting',
  },
  'Failed to fetch SIP accounts': 'Failed to fetch SIP accounts',
  'Username is required': 'Username is required',
  'Username must be at least 4 characters': 'Username must be at least 4 characters',
  'Password is required': 'Password is required',
  'Password must be at least 6 characters': 'Password must be at least 6 characters',
  'SIP account deleted successfully': 'SIP account deleted successfully',
  'All Type': 'All Type',
  WebRTC: 'WebRTC',
  SIP: 'SIP',
  'All Status': 'All Status',
  Online: 'Online',
  Offline: 'Offline',
  Search: 'Search',
  'Number of Accounts': 'Number of Accounts',
  Type: 'Type',
  'Max Contacts': 'Max Contacts',
  Status: 'Status',
  'Assigned To': 'Assigned To',
  Creator: 'Creator',
  'Create Date': 'Create Date',
  Actions: 'Actions',
  Assigned: 'Assigned',
  Unassigned: 'Unassigned',
  Edit: 'Edit',
  Delete: 'Delete',
  Create: 'Create',
  Update: 'Update',
  Username: 'Username',
  'Username Range': 'Username Range',
  Prefix: 'Prefix',
  From: 'From',
  To: 'To',
  'Prefix is required': 'Prefix is required',
  'From and To values must have the same number of digits':
    'From and To values must have the same number of digits',
  'To value must be greater than From value': 'To value must be greater than From value',
  'SIP Domain': 'SIP Domain',
  Password: 'Password',
  Category: 'Category',
  Cancel: 'Cancel',
  'Are you sure you want to delete account': 'Are you sure you want to delete account',
  'Delete Account': 'Delete Account',
  Account: 'Account',
  'Create Account': 'Create Account',
  'Edit Account': 'Edit Account',
  'Number of Door Lock': 'Number of Door Lock',
  'Lock Management': 'Lock Management',
  Installed: 'Installed',
  Uninstalled: 'Uninstalled',
  Refresh: 'Refresh',
  UUID: 'UUID',
  'Relay ID': 'Relay ID',
  'Door ID': 'Door ID',
  'Install Date': 'Install Date',
  'Lock created successfully': 'Lock created successfully',
  'Failed to create lock': 'Failed to create lock',
  'Lock updated successfully': 'Lock updated successfully',
  'Failed to update lock': 'Failed to update lock',
  'Lock deleted successfully': 'Lock deleted successfully',
  'Failed to delete lock': 'Failed to delete lock',
  'Failed to fetch locks': 'Failed to fetch locks',
  'Are you sure you want to delete the lock "{{uuid}}"?':
    'Are you sure you want to delete the lock "{{uuid}}"?',
  'Subscription Subject *': 'Subscription Subject *',
  'Publish Subject *': 'Publish Subject *',
  'Wifi Name': 'Wifi Name',
  'Wifi Password': 'Wifi Password',
  'UUID is required': 'UUID is required',
  'Relay ID is required': 'Relay ID is required',
  'Subscription Subject is required': 'Subscription Subject is required',
  'Publish Subject is required': 'Publish Subject is required',
  All: 'All',
  'Create Lock': 'Create Lock',
  Save: 'Save',
  'Edit Lock': 'Edit Lock',
  'Subscription Subject': 'Subscription Subject',
  'Publish Subject': 'Publish Subject',
  Confirm: 'Confirm',
  'SIP account removed successfully': 'SIP account removed successfully',
  'All SIP': 'All SIP',
  'Assigned SIP': 'Assigned SIP',
  'Unassigned SIP': 'Unassigned SIP',
  'Community Name': 'Community Name',
  'Institute Name': 'Institute Name',
  'Contact Name': 'Contact Name',
  'SIP Account': 'SIP Account',
  Remove: 'Remove',
  'Remove SIP Account': 'Remove SIP Account',
  'Are you sure you want to remove this SIP account?':
    'Are you sure you want to remove this SIP account?',
  'Select Community': 'Select Community',
  'SIP account assigned successfully': 'SIP account assigned successfully',
  'SIP Account Setting': 'SIP Account Setting',
  'Select one from unassigned SIP List': 'Select one from unassigned SIP List',
  'Select SIP Account': 'Select SIP Account',
  'Select Building': 'Select Building',
  'All Floor': 'All Floor',
  Floor: 'Floor',
  'Room No.': 'Room No.',
  'Building Name': 'Building Name',
  'Please select a SIP account': 'Please select a SIP account',
  'Public Entrance': 'Public Entrance',
  'Building Entrance': 'Building Entrance',
  'Community List': 'Community List',
  'Lock UUID': 'Lock UUID',
  'WebRTC Account': 'WebRTC Account',
  'All Locks': 'All Locks',
  'Lock Assigned': 'Lock Assigned',
  'Lock Unassigned': 'Lock Unassigned',
  'WebRTC Assigned': 'WebRTC Assigned',
  'WebRTC Unassigned': 'WebRTC Unassigned',
  'All WebRTC': 'All WebRTC',
  'Entrance Name': 'Entrance Name',
  'Please select a webrtc account': 'Please select a webrtc account',
  'Please select a lock': 'Please select a lock',
  'Select Webrtc Account': 'Select Webrtc Account',
  'Select Lock': 'Select Lock',
  Setting: 'Setting',
  'Select one from unassigned Webrtc List': 'Select one from unassigned Webrtc List',
  'Select one from unassigned Lock List': 'Select one from unassigned Lock List',
  'Community deleted successfully': 'Community deleted successfully',
  Community: 'Community',
  'Total Communities': 'Total Communities',
  'Total Buildings': 'Total Buildings',
  'In Service': 'In Service',
  'Total Rooms': 'Total Rooms',
  Income: 'Income',
  Active: 'Active',
  Inactive: 'Inactive',
  'Search communities...': 'Search communities...',
  '+ Create New': '+ Create New',
  'Community ID': 'Community ID',
  Room: 'Room',
  'Service Time': 'Service Time',
  Staff: 'Staff',
  'Delete Community': 'Delete Community',
  'Are you sure you want to delete this community? This action cannot be undone.':
    'Are you sure you want to delete this community? This action cannot be undone.',
  Entrance: 'Entrance',
  Building: 'Building',
  Contract: 'Contract',
  'Start Service': 'Start Service',
  'Stop Service': 'Stop Service',
  'Delete Successfully': 'Delete Successfully',
  'Add New': 'Add New',
  Rooms: 'Rooms',
  'Lock ID': 'Lock ID',
  'Start Time': 'Start Time',
  'End Time': 'End Time',
  'Delete Building': 'Delete Building',
  'Are you sure you want to delete this building? This action cannot be undone.':
    'Are you sure you want to delete this building? This action cannot be undone.',
  'Contract ID': 'Contract ID',
  Amount: 'Amount',
  Due: 'Due',
  'Create New': 'Create New',
  'Delete Contract': 'Delete Contract',
  'Are you sure you want to delete this contract? This action cannot be undone.':
    'Are you sure you want to delete this contract? This action cannot be undone.',
  'Please fill in all required fields': 'Please fill in all required fields',
  'Edit Building': 'Edit Building',
  'Create New Building': 'Create New Building',
  'Building ID': 'Building ID',
  'Building Address': 'Building Address',
  longitude: 'longitude',
  latitude: 'latitude',
  'Service Range (Meters)': 'Service Range (Meters)',
  Contacts: 'Contacts',
  'Contacts Phone': 'Contacts Phone',
  Email: 'Email',
  'Edit Community': 'Edit Community',
  'Create New Community': 'Create New Community',
  'Community Address': 'Community Address',
  'Start date must be before end date': 'Start date must be before end date',
  'Payment amount must be greater than 0': 'Payment amount must be greater than 0',
  'Contract created successfully': 'Contract created successfully',
  'Contract updated successfully': 'Contract updated successfully',
  'Start Date': 'Start Date',
  'End Date': 'End Date',
  'Payment Date': 'Payment Date',
  'Payment Amount': 'Payment Amount',
  'Entrance updated successfully': 'Entrance updated successfully',
  'Entrance created successfully': 'Entrance created successfully',
  'Entrance save error': 'Entrance save error',
  'Edit Entrance': 'Edit Entrance',
  'Create New Entrance': 'Create New Entrance',
  'Entrance ID': 'Entrance ID',
  'Entrance Address': 'Entrance Address',
  'Public service updated successfully': 'Public service updated successfully',
  'Public service created successfully': 'Public service created successfully',
  'Public service save error': 'Public service save error',
  'Edit Public Service': 'Edit Public Service',
  'Create New Public Service': 'Create New Public Service',
  'Institution Name': 'Institution Name',
  'Is Public': 'Is Public',
  'Not Public': 'Not Public',
  'Room updated successfully': 'Room updated successfully',
  'Room created successfully': 'Room created successfully',
  'Room save error': 'Room save error',
  'Edit Room': 'Edit Room',
  'Create New Room': 'Create New Room',
  'Room ID': 'Room ID',
  'Room Number': 'Room Number',
  'Entrance deleted successfully': 'Entrance deleted successfully',
  'Entrance delete error': 'Entrance delete error',
  'Delete Entrance': 'Delete Entrance',
  'Are you sure you want to delete this entrance? This action cannot be undone.':
    'Are you sure you want to delete this entrance? This action cannot be undone.',
  'Select Location': 'Select Location',
  'Public Service': 'Public Service',
  'Public service deleted successfully': 'Public service deleted successfully',
  'Public service delete error': 'Public service delete error',
  'Delete Public Service': 'Delete Public Service',
  'Are you sure you want to delete this public service? This action cannot be undone.':
    'Are you sure you want to delete this public service? This action cannot be undone.',
  'Select Floor': 'Select Floor',
  'All Floors': 'All Floors',
  'Room No': 'Room No',
  'Delete Room': 'Delete Room',
  'Are you sure you want to delete this room? This action cannot be undone.':
    'Are you sure you want to delete this room? This action cannot be undone.',
  'End Service': 'End Service',
  'Service Time Error': 'Service Time Error',
  Longitude: 'Longitude',
  Latitude: 'Latitude',
  Download: 'Download',
  'Entrance QR Code': 'Entrance QR Code',
  'Building QR Code': 'Building QR Code',
  'all building': 'all building',
  'Invalid URL parameters': 'Invalid URL parameters',
  'Call To': 'Call To',
  'Hang up': 'Hang up',
  'Please connect to the network': 'Please connect to the network',
  'Call in progress': 'Call in progress',
  'Call failed': 'Call failed',
  'Call connected': 'Call connected',
  'Call Room': 'Call Room',
  'Are you sure you want to call this number room?':
    'Are you sure you want to call this {{number}} room?',
  Call: 'Call',
  'Checking microphone access...': 'Checking microphone access...',
  'Checking microphone...': 'Checking microphone...',
  'Please allow microphone access': 'Please allow microphone access',
  'Microphone not found': 'Microphone not found',
  'Cannot access your microphone': 'Cannot access your microphone',
  'Detecting your location...': 'Detecting your location...',
  'Verifying your location...': 'Verifying your location...',
  'Getting location...': 'Getting location...',
  'verifying location...': 'verifying location...',
  'Please allow location access': 'Please allow location access',
  'Location verified': 'Location verified',
  'Exceeding the service distance': 'Exceeding the service distance',
  'Error checking location': 'Error checking location',
  'Error checking microphone': 'Error checking microphone',
  'Request Permission': 'Request Permission',
  'Request Open Door': 'Request Open Door',
  'Connecting...': 'Connecting...',
  Connected: 'Connected',
  Disconnected: 'Disconnected',
  Ready: 'Ready',
  'Registration Failed': 'Registration Failed',
  'Calling...': 'Calling...',
  Service: 'Service',
  User: 'User',
  lat: 'lat',
  long: 'long',
  'Door Name': 'Door Name',
  'Transfer Name': 'Transfer Name',
  'Transfer Address': 'Transfer Address',
  'Transfer Password': 'Transfer Password',
  roomNumber: 'Room Number',
  'If location and microphone usage permissions have not been granted, please refresh the page and re authorize!':
    'If location and microphone usage permissions have not been granted, please refresh the page and re authorize!',
  'Refresh page': 'Refresh page',
  'Call ends in': 'Call ends in:',
  'Call ended due to timeout': 'Call ended due to timeout',
  'Call ended': 'Call ended',
  bulk_create: 'Bulk Create',
  'Bulk Create Account': 'Bulk Create Account',
  'Successfully created count_SIP accounts': 'Successfully created {{count_SIP}} SIP accounts',
  voice_call: 'Voice Call',
  video_call: 'Video Call',
  'Please input all required fields': 'Please input all required fields',
  'Please input valid domain': 'Please input valid domain',
  'Please save the call center first': 'Please save the call center first',
  'Please select a category first': 'Please select a category first',
  'Call Center Name': 'Call Center Name',
  Agent: 'Agent',
  URL: 'URL',
  'Search call centers...': 'Search call centers...',
  'Access Domain Name': 'Access Domain Name',
  'Category List': 'Category List',
  'Agent List': 'Agent List',
  No: 'No',
  'No result': 'No result',
  'Assigned Sip List': 'Assigned Sip List',
  Duty: 'Duty',
  isPublic: 'Public',
  Avatar: 'Avatar',
  'Click to upload image': 'Click to upload image',
  'Click to upload file': 'Click to upload file',
  Name: 'Name',
  Gender: 'Gender',
  email: 'Email',
  'Sip Account': 'Sip Account',
  category_name: 'Category Name',
  'Agent Info': 'Agent Info',
  Male: 'Male',
  Female: 'Female',
  Yes: 'Yes',
  no: 'No',
  Preview: 'Preview',
  QRCode: 'QRCode',
  male: 'Male',
  female: 'Female',
  'Save Successfully': 'Save Successfully',
  'Update Successfully': 'Update Successfully',
  'Call Center QR Code': 'Call Center QR Code',
  'Customer Service': 'Customer Service',
  'Search agents...': 'Search agents...',
  Categories: 'Categories',
  'Select a category': 'Select a category',
  'No agents available': 'No agents available',
  'Voice Call': 'Voice Call',
  'Video Call': 'Video Call',
  'Call Agent': 'Call Agent',
  'Are you sure you want to call': 'Are you sure you want to call',
  'Please wait for connection to be established': 'Please wait for connection to be established',
  'Failed to load call center data': 'Failed to load call center data',
  'Please allow camera and microphone access to make video calls':
    'Please allow camera and microphone access to make video calls',
  'Please allow microphone access to make voice calls':
    'Please allow microphone access to make voice calls',
  'Camera or microphone not found': 'Camera or microphone not found',
  'Unable to access media devices': 'Unable to access media devices',
  'Call rejected or busy': 'Call rejected or busy',
  'The agent is busy or rejected the call': 'The agent is busy or rejected the call',
  'Agent not found': 'Agent not found',
  'The agent could not be reached': 'The agent could not be reached',
  'Call timeout': 'Call timeout',
  'The agent did not answer': 'The agent did not answer',
  'Service unavailable': 'Service unavailable',
  'Call service is currently unavailable': 'Call service is currently unavailable',
  'Call failed. Please try again.': 'Call failed. Please try again.',
  'Call was rejected': 'Call was rejected',
  'Call ended by remote party': 'Call ended by remote party',
  'Call ended due to connection error': 'Call ended due to connection error',
  'Connection error occurred': 'Connection error occurred',
  'Connection lost': 'Connection lost',
  'Network connection lost': 'Network connection lost',
  'Connection closed': 'Connection closed',
  'Connection failed': 'Connection failed',
  'Call connection failed': 'Call connection failed',
  'Failed to play remote video': 'Failed to play remote video',
  'Failed to play audio': 'Failed to play audio',
  'This category has agents assigned to it. Are you sure you want to delete it? All agents will be deleted from this category.':
    'This category has agents assigned to it. Are you sure you want to delete it? All agents will be deleted from this category.',
  'Delete Category': 'Delete Category',
  'Are you sure you want to delete this category? This action cannot be undone.':
    'Are you sure you want to delete this category? This action cannot be undone.',
  'Delete Call Center': 'Delete Call Center',
  'Are you sure you want to delete this call center? This action cannot be undone.':
    'Are you sure you want to delete this call center? This action cannot be undone.',
  'This call center has categories assigned to it. Are you sure you want to delete it? All categories will be deleted from this call center.':
    'This call center has categories assigned to it. Are you sure you want to delete it? All categories will be deleted from this call center.',
  'Delete Agent': 'Delete Agent',
  'Are you sure you want to delete this agent? This action cannot be undone.':
    'Are you sure you want to delete this agent? This action cannot be undone.',
  ECard: 'ECard',
  'ECard Info': 'ECard Info',
  'Delete ECard': 'Delete ECard',
  'Are you sure you want to delete this ECard? This action cannot be undone.':
    'Are you sure you want to delete this ECard? This action cannot be undone.',
  'ECard QR Code': 'ECard QR Code',
  'Search ECards...': 'Search ECards...',
  'This ecard is not public. Please contact the administrator to get the public ecard.':
    'This ecard is not public. Please contact the administrator to get the public ecard.',
  Copy: 'Copy',
  'Copied to clipboard': 'Copied to clipboard',
  'Initiate Call': 'Initiate Call',
  ConfirmCall: 'Confirm',
  'Optimizing Network' : 'Optimizing Network...',
  'Are you sure you want to call this number?': 'Are you sure you want to call this {{number}}?',
  'ECard Loading...': 'ECard Loading...',
};

export default zh;
